<form>
    <div class="title-outer">
        <h2 class="form-title">{{ languageService.languageJSON.MainDashboard_RecalledComponents }}</h2>
    </div>

    <div class="form-section-function">
        <div class="flex-col">
            <div class="flex-row">
                <app-multiple-search [searchFields]="recalledFields" [searchByList]="searchByList" (searchByListChange)="onSearchListChange($event)">
                </app-multiple-search>
                <div class="row-to-right" *ngIf="hasComponentSetRecalledFlagRole()">
                    <button type="button" routerLink="/recalled-upload">
                        {{ languageService.languageJSON.ComponentRecalled_BulkAction}}</button>
                    <button type="button" (click)="markSelectedAsRecalledClick()"
                        *ngIf="!selectedElements || !markAsUnrecalled" [ngClass]="{inactive: !selectedElements}">
                        {{ languageService.languageJSON.ComponentRecalled_MarkSelectedAsRecalled}}</button>
                    <button type="button" (click)="markSelectedAsUnrecalledClick()"
                        *ngIf="selectedElements && markAsUnrecalled" [ngClass]="{inactive: !selectedElements}">
                        {{ languageService.languageJSON.ComponentRecalled_MarkSelectedAsUnrecalled}}</button>
                </div>
            </div>
            <div class="flex-row">
                <app-search-badge [searchByList]="searchByList" [listFields]="recalledFields" (searchByListChange)="onSearchListChange($event)">
                </app-search-badge>
            </div>
        </div>
    </div>

    <div class="form-section table">
        <div class="flex-outer flex-column table">
            <div class="flex-row header">
                <div class="flex-col short-col">
                    <mat-checkbox color="primary" name="select all" [(ngModel)]="selectAll"
                        [ngModelOptions]="{standalone: true}" (change)="selectAllStateChanged()">
                    </mat-checkbox>
                </div>
                <div class="flex-col"
                    [ngClass]="{'medium-col': recalledField.Id<=4, 'clickable':recalledField.GroupBy, 'bold':order==recalledField.FieldName}"
                    *ngFor="let recalledField of recalledFields"
                    (click)="setOrder(recalledField.FieldName, recalledField.GroupBy)">
                    {{ recalledField.DisplayName }}
                    <span class="order-icon" *ngIf="order==recalledField.FieldName && !reverse">▼</span>
                    <span class="order-icon" *ngIf="order==recalledField.FieldName && reverse">▲</span>
                </div>
            </div>
            <ng-scrollbar [orientation]="'vertical'">
                <div class="flex-row" *ngFor="let component of recalledComponentList
                | paginate: { itemsPerPage: itemsPerPage, currentPage: page, totalItems: totalItems }; let index = index;">
                    <div class="flex-col short-col">
                        <mat-checkbox color="primary" [name]="component.SerialNumber" [(ngModel)]="component.checked"
                            [ngModelOptions]="{standalone: true}" (change)="shiftSelectComponentId($event, index)"
                            [ngClass]="{'last-selected': lastSelectedComponentId==index}">
                        </mat-checkbox>
                    </div>

                    <div class="flex-col" *ngFor="let recalledField of recalledFields"
                        [ngClass]="{'medium-col': recalledField.Id<=4, 'uppercase': recalledField.Uppercase}">
                        <span *ngIf="recalledField.Id<4">
                            {{ component[recalledField.FieldName] }}
                        </span>
                        <span *ngIf="recalledField.Id==4">
                            <div class="green-circle" *ngIf="component[recalledField.FieldName]==0"
                            [matTooltip]="languageService.languageJSON.ComponentRecalled_Unrecalled" matTooltipClass="configtool-tooltip"></div>
                            <div class="red-circle" *ngIf="component[recalledField.FieldName]==1"
                            [matTooltip]="languageService.languageJSON.ComponentRecalled_Recalled" matTooltipClass="configtool-tooltip"></div>
                        </span>
                    </div>
                </div>
                <div class="flex-row" *ngIf="recalledComponentList.length==0 && !loading">
                    <div class="flex-col" *ngIf="!hasAnySearchElement()">{{ languageService.languageJSON.Global_NoItems }}</div>
                    <div class="flex-col" *ngIf="hasAnySearchElement()">{{ languageService.languageJSON.Global_NoResult }}</div>
                </div>
            </ng-scrollbar>
            <!-- paginator -->
            <app-loading-animation *ngIf="loading"></app-loading-animation>
        </div>
    </div>
    <div class="pagination" *ngIf="!loading">
        <div class="pagination-text">{{ getPaginationText() }}</div>
        <pagination-controls (pageChange)="onPageChangeEvent($event)"></pagination-controls>
        <div class="pagination-page">
            <span class="desc">{{languageService.languageJSON.ComponentRecalled_Rows }}:</span>
            <mat-select [(value)]="itemsPerPage">
                <mat-option *ngFor="let itemPerPage of paginationValues" [value]="itemPerPage" (click)="itemsPerPageChanged()">
                    {{ itemPerPage }}</mat-option>
            </mat-select>
        </div>
        
    </div>

</form>